import React from 'react';
import DateCommon from './DateCommon';
import Month from './Month';
import Time from './Time';
import Range from './Range';
export * from './Month';
export * from './Time';
export * from './Range';

const DatePicker = props => {
  return /*#__PURE__*/React.createElement(DateCommon, props);
};

DatePicker.Time = Time;
DatePicker.Month = Month;
DatePicker.Range = Range;
export default DatePicker;